<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-navy-900/60 backdrop-blur-sm p-4"
  (click)="onBackdropClick($event)"
>
  <div class="bg-white rounded-2xl shadow-xl w-full max-w-sm flex flex-col overflow-hidden">
    <!-- Header -->
    <div class="flex items-start justify-between px-6 pt-6 pb-4">
      <h2 class="text-base font-bold text-navy-900">{{ title() }}</h2>
      <button
        (click)="closed.emit()"
        class="w-8 h-8 flex items-center justify-center rounded-full border border-surface-300 hover:bg-surface-100 transition-colors cursor-pointer shrink-0"
      >
        <img src="/icons/close-icon.svg" class="w-3.5 h-3.5" alt="Close" />
      </button>
    </div>

    <!-- Body -->
    <!-- Projected content (e.g. with bold parts) replaces the plain message. -->
    <p class="px-6 pb-6 text-sm text-slate-500">
      <ng-content>{{ message() }}</ng-content>
    </p>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-surface-200 flex items-center justify-end gap-3">
      <button
        type="button"
        (click)="closed.emit()"
        class="px-5 py-2.5 text-sm font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="confirmed.emit()"
        class="px-5 py-2.5 text-sm font-semibold text-white bg-red-500 hover:opacity-90 rounded-xl transition-opacity cursor-pointer"
      >
        {{ confirmLabel() }}
      </button>
    </div>
  </div>
</div>
